import {PANEL_UNSET_PARAM} from '~/frontend/src/constants';

export type UnsetParamAction = {
    type : typeof PANEL_UNSET_PARAM;
    panelKey : string;
    paramKey : string;
}


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} paramKey
 *
 * @return {UnsetParamAction}
 */
export default function unsetParam( panelKey : string, paramKey : string ) : UnsetParamAction {
    return {
        type: PANEL_UNSET_PARAM,
        panelKey,
        paramKey
    };
}

export type UnsetParam = typeof unsetParam;
